import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { PrivilegeService } from '../../privilege.service';

import { PrivilegeCreate, PrivilegeDelete, PrivilegeRefresh, PrivilegeUpdate } from './privilege.action';
import { Privilege } from 'src/app/components/catalogs/roles/services/role-privilege';

export class PrivilegeStateModel {
  data: Privilege[] = [];
  // Permission answers must wait for privilege names as well as role mappings.
  loaded: boolean = false;
}

@State<PrivilegeStateModel>({
  name: 'Privileges',
  defaults: {
    data: [],
    loaded: false,
  }
})
@Injectable()
export class PrivilegeState extends BaseState {
  constructor(
    protected override injector: Injector,
    private _service: PrivilegeService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: PrivilegeStateModel) {
    return state.data;
  }

  @Action(PrivilegeRefresh)
  refresh({ patchState }: StateContext<PrivilegeStateModel>) {
    patchState({ loaded: false });
    this._service.getAll().toPromise().then(data => {
      patchState({ data, loaded: true });
    }).catch(error => {
      console.error(error);
    });
  }

  @Action(PrivilegeCreate)
  create({ getState, patchState }: StateContext<PrivilegeStateModel>, { item }: PrivilegeCreate) {
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(PrivilegeUpdate)
  update({ getState, patchState }: StateContext<PrivilegeStateModel>, { id, item }: PrivilegeUpdate) {
    const state = getState();
    const index = state.data.findIndex(x => x.id === id);
    const currentState = state.data;

    if (index >= 0) {
      currentState.splice(index, 1, item);
      patchState({ data: currentState });
    }
  }

  @Action(PrivilegeDelete)
  delete({ getState, patchState }: StateContext<PrivilegeStateModel>, { id }: PrivilegeDelete) {
    patchState({
      data: getState().data.filter(x => x.id !== id)
    });
  }
}
